import { StandardStatusType } from '../../common/common.types';

export const DEFAULT_STANDARDS_STATUS: StandardStatusType[] = [
  'custom',
  'system',
  'draft',
];
